import request from '@/utils/request'

//项目列表查询
export function projectListData(data) {
  return request({
    url: '/project/list',
    method: 'post',
    data: data
  })
}

//新增项目立项信息
export function addProject(data) {
  return request({
    url: '/project/add',
    method: 'post',
    data: data
  })
}
//修改项目立项信息
export function editProject(data) {
  return request({
    url: '/project/edit',
    method: 'post',
    data: data
  })

}
//删除项目立项信息
export function deleteProject(data) {
  return request({
    url: '/project/remove',
    method: 'post',
    data: data
  })
}

//项目的任务包列表
export function packageList(data) {
  return request({
    url: '/projectPackage/list',
    method: 'post',
    data: data
  })
}
//项目详情接口
export function projectInfo(id) {
  return request({
    url: '/project/projectInfo/' + id,
    method: 'get',
  })
}
//任务包详情接口
export function packageInfo(id) {
  return request({
    url: '/projectPackage/packageInfo/' + id,
    method: 'get',
  })
}

//获取接包方申请验收任务包的说明或理由
export function applyAcceptDeclare(id) {
  return request({
    url: '/projectPackage/applyAcceptDeclare/' + id,
    method: 'get',
  })
}




//新增任务包
export function addPackageInfo(data) {
  return request({
    url: '/projectPackage/add',
    method: 'post',
    data: data
  })
}
//修改任务包
export function editPackageInfo(data) {
  return request({
    url: '/projectPackage/edit',
    method: 'post',
    data: data
  })
}
//删除任务包
export function deletePackage(id) {
  return request({
    url: '/projectPackage/remove',
    method: 'post',
    data: id
  })
}
//获取包下面的报名人员
export function forPackageEmpolerList(query) { //packageId,sortType
  return request({
    url: '/apply/list/' + query.packageId + '/' + query.sortType,
    method: 'get',
  })
}
//获取包的剩余时间信息 报名截止信息 http://域名/apply/endApplyInfo/{packageId}
export function endApplyInfo(packageId) {
  return request({
    url: '/apply/endApplyInfo/' + packageId,
    method: 'get',
  })
}
/*任务包确认合作对象   */
export function confirmCooperation(query) {
  return request({
    url: '/apply/confirmCooperation/',
    method: 'post',
    data: query
  })
}
/*任务包审核不通过原因查询 */
export function notPassReasonForPackage(id) {
  return request({
    url: '/projectPackage/notPassReason/' + id,
    method: 'get',
  })
}
//任务包评价
export function evaluate(data) {
  return request({
    url: '/workerEvaluate/evaluate',
    method: 'post',
    data: data
  })
}
/*任务包发布 */
export function packagePublish(data) {
  return request({
    url: '/projectPackage/publish',
    method: 'post',
    data: data
  })
}
/*任务包验收 */
export function packageAccept(data) {
  return request({
    url: '/packageAccept/accept',
    method: 'post',
    data: data
  })
}
/*任务包验收记录 http://域名/packageAccept/list*/
export function packageAcceptList(id) {
  return request({
    url: '/packageAccept/list',
    method: 'post',
    data: id
  })
}
/*任务包取消发布 http://域名/projectPackage/cancelPublish*/
export function cancelPublish(id) {
  return request({
    url: '/projectPackage/cancelPublish',
    method: 'post',
    data: id
  })
}
/*  价格评估模型查询http://域名/priceModel/{type} */
export function priceModel(type) {
  return request({
    url: '/priceModel/' + type,
    method: 'get',
  })
}
/*价格预测  http://域名/priceModel/estimatedPrice */
export function estimatedPrice(ids) {
  return request({
    url: '/priceModel/estimatedPrice',
    method: 'post',
    data: ids
  })
}
/*  是否存在项目编号 http://域名/project/isHasProjectNo */
export function isHasProjectNo(id) {
  return request({
    url: '/project/isHasProjectNo',
    method: 'post',
    data: id
  })
}
/*、http://域名/packageAccept/applyList*/
export function applyFileList(data) {
  return request({
    url: '/packageAccept/applyList',
    method: 'post',
    data: data
  })
}
/*/maintenance/list/{{projectId}}*/
export function maintenance(data) {
  return request({
    url: '/maintenance/list/',
    method: 'post',
    data: data
  })
}
/*新增应用模块*/
export function addMaintenance(data) {
  return request({
    url: '/maintenance/',
    method: 'post',
    data: data
  })
}
/*新增应用模块*/
export function maintenanceDetail(id) {
  return request({
    url: '/maintenance/' + id,
    method: 'get',
  })
}
/*修改应用模块*/
export function editMaintenance(data) {
  return request({
    url: '/maintenance/',
    method: 'put',
    data: data
  })
}
//删除应用模块
export function deleteMaintenance(id) {
  return request({
    url: '/maintenance/' + id,
    method: 'delete',
  })
}
/*建模包预览*/
export function previewModel(id) {
  return request({
    url: '/packageAccept/preview/' + id,
    method: 'get',
  })
}
/*任务包价格评估方式*/
export function newEvaluate(type) {
  return request({
    url: '/evaluate/' + type,
    method: 'get',
  })
}
/*任务包价格计算*/
export function getEvaluate(data) {
  return request({
    url: '/evaluate',
    method: 'post',
    data
  })
}
/*实施和运维包单价（日薪）查询
*/
export function evaluateByCity(cityId, packageType) {
  return request({
    url: '/evaluate/level?cityId=' + cityId + '&packageType=' + packageType,
    method: 'get',
  })
}


export function getCode(phone) {
  return request({
    url: '/projectPackage/sendCode/' + phone + '/10',
    method: 'get',
  })
}

export function checkCode(phone, code) {
  return request({
    url: '/projectPackage/checkSmsCode/' + phone + '/' + code,
    method: 'get',
  })
}

/* 获取当前查看价格详情 */
export function getPriceInfo(data) {
  return request({
    url: '/maintenance/getPriceInfo',
    method: 'post',
    data
  })
}


/* 提交整包 金额支付  */
export function setPublish(data) {
  return request({
    url: '/project/publish',
    method: 'post',
    data
  })
}

// 建模包部署接口
export function getDeployApp(id) {
  return request({
    url: '/kepler/deployApp?packageId=' + id,
    method: 'get',
  })
}


/* 修改时间接口  */
export function setEditTime(data) {
  return request({
    url: '/projectPackage/employer/updatePackageTime',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/employer/project/project.js